import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DynamicService } from 'src/app/services/dynamic.service';
import { MasterService } from 'src/app/services/master.service';
import { MessageService } from 'src/app/services/message.service';
import { token } from '../../roles.component';
import * as languageLibrary from '../../../../../../../services/language'
import { Contact } from 'src/app/models/contact.model';
import { InsurancePolicy } from 'src/app/models/insurance-policy.model';

@Component({
    selector: 'personal-auto-insurance',
    templateUrl: './personal-auto-insurance.component.html',
    styleUrls: ['./personal-auto-insurance.component.scss'],
    standalone: false
})
export class PersonalAutoInsuranceComponent implements OnInit {
    @Input() contactId: number

    /** */
    protected contactRoleId: number = 0
    
    /** */
    protected words = languageLibrary.language
    
    /** */
    protected language: string = 'EN'
    
    /** */
    public policyInformation = new FormGroup({
        id: new FormControl<number>(null),
        contactId: new FormControl<number>(null, [Validators.required]),
        insuranceContactId: new FormControl<number>(null, [Validators.required]),
        provider: new FormControl<string | null>(null),
        policyNumber: new FormControl<string | null>(null),
        effectiveFrom: new FormControl<string | null>(null),
        expiryDate: new FormControl<string | null>(null)
    })
    
    /** */
    public providers: Contact[] = []
    
    /** */
    public policies: InsurancePolicy[] = []
    
    /** */
    protected dataIn: Object;
    
    /** */
    public id: number = 0;
    
    constructor(private master: MasterService, private ms: MessageService, private inject: Injector, private serv: DynamicService) {}

    deactivateRole() {
        this.serv.outputFromDynamicComponent({ action: "deactivate", contactRoleId: this.contactRoleId });
    }

    ngOnInit(): void {
        this.dataIn = this.inject.get(token);
        this.contactId = this.dataIn['contactId']
        this.contactRoleId = this.dataIn['contactRoleId']

        if (!this.contactId) {
            return
        }

        this.policyInformation.get("contactId").setValue(this.contactId)

        this.getPersonalAutoInsurance()
    }

    public getPersonalAutoInsurance() {
        this.resetInformation()
        this.master.get(`contacts/${this.contactId}/personalAutoInsurance`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            if (res.data.contactPersonalAutoInsurance.length == 0) {
                return
            }

            this.policies = res.data.contactPersonalAutoInsurance
        })
    }

    public savePersonalAutoInsurance() {
        if (this.policyInformation.get("effectiveFrom").value == "") { this.policyInformation.get("effectiveFrom").setValue(null) }
        if (this.policyInformation.get("expiryDate").value == "") { this.policyInformation.get("expiryDate").setValue(null) }
        if (this.policyInformation.invalid) {
            return
        }

        if (this.id <= 0) {
            this.createPersonalAutoInsurance()
            return
        }

        this.modifyPersonalAutoInsurance()
    }

    createPersonalAutoInsurance() {
        this.master.post(`contacts/${this.contactId}/personalAutoInsurance`, { information: this.policyInformation.value, }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            document.getElementById("btn-cancel-personal-auto-insurance").click()
            this.getPersonalAutoInsurance()

        })
    }

    modifyPersonalAutoInsurance() {
        this.master.put(`contacts/${this.contactId}/personalAutoInsurance/${this.id}`, { information: this.policyInformation.value, }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.getPersonalAutoInsurance()
            document.getElementById("btn-cancel-personal-auto-insurance-modify").click()
        })
    }

    deletePersonalAutoInsurance() {
        this.master.discard(`contacts/${this.contactId}/personalAutoInsurance/${this.id}`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.getPersonalAutoInsurance()
            document.getElementById("btn-cancel-personal-auto-insurance-delete").click()
        })
    }

    resetInformation() {
        this.policyInformation.reset({
            contactId: this.contactId
        })
        this.id = null
    }

    setInformation(info: InsurancePolicy) {
        this.id = info.id
        this.policyInformation.setValue({
            id: info.id,
            contactId: this.contactId,
            insuranceContactId: info.insuranceContactId,
            provider: info.provider,
            policyNumber: info.policyNumber,
            effectiveFrom: info.effectiveFrom instanceof Date ? info.effectiveFrom.toISOString().split('T')[0] : info.effectiveFrom,
            expiryDate: info.expiryDate instanceof Date ? info.expiryDate.toISOString().split('T')[0] : info.expiryDate
        })
    }

    public setContactIdEvent(e) {
        if (!e) {
            return
        }

        this.policyInformation.get("insuranceContactId").setValue(e)
    }
}